import { c as _c } from "react/compiler-runtime";
import { ActionIcon, Popover, ScrollArea } from '@mantine/core';
import { CSSProperties, ReactNode, cloneElement, useLayoutEffect, useState, ReactElement, useId } from 'react';
import { HiDotsVertical } from 'react-icons/hi';
import { StyleProps, WrapIf, useElementSize, useSizeToPx, useWindowDim } from 'shared/ui';
import { isEmpty, omit } from 'remeda';
import { isMobile } from 'react-device-detect';
import { getFlattenedChildren } from 'shared/ui/reactNode';
import { Glass } from './Glass';
import { twMerge } from 'tailwind-merge';
import { useIntersection, useMediaQuery, useMergedRef } from '@mantine/hooks';
import { useSticky } from './Sticky';
const isHtmlElement = (element: unknown): element is HTMLElement => element instanceof HTMLElement;
const propsAsObject = <T extends {},>(n: {
  props: unknown;
}): T => (n.props ?? {}) as T;
type ItemProps = {
  style?: CSSProperties;
};

/** A panel with buttons or status that can be scrolled horizontally on mobile (no scrollbars tho) and overflows into a OverFlowMenu on desktop screens.
 * use style gap not tailwind to make working
 */
export const ActionPanel = t0 => {
  const $ = _c(34);
  const {
    children,
    className,
    style: styleRaw
  } = t0;
  const [itemState, setItemState] = useState();
  const {
    ref,
    width: containerWidth
  } = useElementSize();
  const gapPx = useSizeToPx(styleRaw?.gap) ?? 6;
  let t1;
  if ($[0] !== gapPx || $[1] !== ref) {
    t1 = () => {
      if (!ref.current) {
        return;
      }
      const totalWidth = ref.current.scrollWidth;
      let cumulatedWidth = 20;
      const items = Array.from(ref.current.querySelectorAll("& > .menu-item")).filter(isHtmlElement).map(t2 => {
        const {
          clientWidth,
          style
        } = t2;
        cumulatedWidth = cumulatedWidth + (clientWidth + gapPx);
        cumulatedWidth;
        const newStyle = {
          ...(isMobile || cumulatedWidth < totalWidth ? {
            visibility: "visible",
            position: "initial"
          } : {
            visibility: "hidden",
            position: "absolute"
          })
        } satisfies CSSProperties;
        (["visibility", "position"] as const).forEach(k => {
          if (newStyle[k] != style[k]) {
            style.setProperty(k, newStyle[k] ?? null);
          }
        });
        return newStyle;
      });
      setItemState({
        totalWidth,
        items
      });
    };
    $[0] = gapPx;
    $[1] = ref;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== containerWidth) {
    t2 = [children, containerWidth, isMobile];
    $[3] = children;
    $[4] = containerWidth;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useLayoutEffect(t1, t2);
  let T0;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] !== children || $[7] !== className || $[8] !== itemState?.items || $[9] !== ref || $[10] !== styleRaw) {
    let t10;
    if ($[19] !== itemState?.items) {
      t10 = (e, i) => ({
        e,
        state: itemState?.items[i]
      });
      $[19] = itemState?.items;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    const menuItems = getFlattenedChildren(children).map(t10);
    const overflowItems = (isMobile ? undefined : menuItems?.filter(_temp)) ?? [];
    let t11;
    if ($[21] !== styleRaw) {
      t11 = {
        gap: "6px",
        ...styleRaw
      };
      $[21] = styleRaw;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    const style_0 = t11;
    T0 = WrapIf;
    t8 = isMobile;
    t9 = _temp2;
    t3 = ref;
    t4 = style_0;
    t5 = `flex items-center grow menu ${isMobile ? "" : "overflow-x-hidden"} ${className ?? ""}`;
    t6 = menuItems?.map(_temp3);
    t7 = !isEmpty(overflowItems) && <Popover><Popover.Target><ActionIcon className="overflow-menu"><HiDotsVertical size="1.3em" /></ActionIcon></Popover.Target><Popover.Dropdown className="flex flex-col" style={style_0}>{overflowItems.map(_temp4)}</Popover.Dropdown></Popover>;
    $[6] = children;
    $[7] = className;
    $[8] = itemState?.items;
    $[9] = ref;
    $[10] = styleRaw;
    $[11] = T0;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    T0 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  let t10;
  if ($[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t10 = <div ref={t3} style={t4} className={t5}>{t6}{t7}</div>;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== T0 || $[30] !== t10 || $[31] !== t8 || $[32] !== t9) {
    t11 = <T0 if={t8} wrap={t9}>{t10}</T0>;
    $[29] = T0;
    $[30] = t10;
    $[31] = t8;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
};
export const ActionCard = t0 => {
  const $ = _c(40);
  const {
    variant: t1,
    children,
    className,
    classNames,
    cheapGlass,
    minWidthForSticky: t2
  } = t0;
  const variant = t1 === undefined ? "sticky" : t1;
  const minWidthForSticky = t2 === undefined ? 600 : t2;
  const {
    ref: intersectionRef,
    entry
  } = useIntersection();
  const {
    ref: stickyRef,
    style: stickyStyle,
    className: stickyClassName
  } = useSticky();
  const {
    w
  } = useWindowDim();
  const shouldUseSticky = variant == "sticky" && (minWidthForSticky == null || w > minWidthForSticky);
  const sticking = shouldUseSticky && entry && !entry.isIntersecting;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      visibility: "hidden"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== intersectionRef || $[2] !== stickyClassName) {
    t4 = <div ref={intersectionRef} style={t3} className={stickyClassName} />;
    $[1] = intersectionRef;
    $[2] = stickyClassName;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = shouldUseSticky && "sticky group";
  const t6 = classNames?.root;
  let t7;
  if ($[4] !== className || $[5] !== t5 || $[6] !== t6) {
    t7 = twMerge(t5, className, t6);
    $[4] = className;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== shouldUseSticky || $[9] !== stickyStyle) {
    t8 = shouldUseSticky ? stickyStyle : {};
    $[8] = shouldUseSticky;
    $[9] = stickyStyle;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = `calc(${stickyStyle?.top ?? "0px"} + 2px)`;
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = {
      ...t8,
      top: t9
    };
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== shouldUseSticky || $[15] !== sticking) {
    t11 = shouldUseSticky ? {
      "data-sticking": sticking
    } : {};
    $[14] = shouldUseSticky;
    $[15] = sticking;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = !sticking;
  const t13 = cheapGlass ? "blur" : undefined;
  const t14 = classNames?.root;
  let t15;
  if ($[17] !== t14) {
    t15 = twMerge(t14);
    $[17] = t14;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  const t16 = sticking && "px-4 py-2";
  const t17 = classNames?.content;
  let t18;
  if ($[19] !== t16 || $[20] !== t17) {
    t18 = twMerge(t16, "transition-all duration-200 ease-in-out flex gap-2 items-center", t17);
    $[19] = t16;
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== t15 || $[23] !== t18) {
    t19 = {
      root: t15,
      content: t18
    };
    $[22] = t15;
    $[23] = t18;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] !== children || $[26] !== sticking || $[27] !== t12 || $[28] !== t13 || $[29] !== t19) {
    t20 = <Glass disabled={t12} mode={t13} showBorder={true} frost={0.7} displace={2} data-sticking={sticking} classNames={t19}>{children}</Glass>;
    $[25] = children;
    $[26] = sticking;
    $[27] = t12;
    $[28] = t13;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== stickyRef || $[32] !== t10 || $[33] !== t11 || $[34] !== t20 || $[35] !== t7) {
    t21 = <div ref={stickyRef} className={t7} style={t10} {...t11}>{t20}</div>;
    $[31] = stickyRef;
    $[32] = t10;
    $[33] = t11;
    $[34] = t20;
    $[35] = t7;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t21 || $[38] !== t4) {
    t22 = <>{t4}{t21}</>;
    $[37] = t21;
    $[38] = t4;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  return t22;
};
function _temp(t0) {
  const {
    state
  } = t0;
  return state?.visibility == "hidden";
}
function _temp2(c) {
  return <ScrollArea>{c}</ScrollArea>;
}
function _temp3(t0, i_0) {
  const {
    e: e_0,
    state: state_0
  } = t0;
  return cloneElement(e_0 as ReactElement<ItemProps>, {
    ...propsAsObject(e_0),
    key: `mi.${i_0}`,
    style: {
      ...state_0,
      ...propsAsObject(e_0).style
    }
  });
}
function _temp4(t0) {
  const {
    e: e_1
  } = t0;
  return cloneElement(e_1 as ReactElement<ItemProps>, {
    ...propsAsObject(e_1),
    key: `mi.${e_1.key}`
  });
}